/* eslint-disable */
import {
    AUTH_REQUEST,
    AUTH_ERROR,
    AUTH_SUCCESS,
    AUTH_LOGOUT,
  } from "@/store/actions/auth"
  // import { settings } from "@/settings"
  import router from "../router";
  import axios from 'axios'
  import { API } from './../api.js'
  export default {
    [AUTH_REQUEST]: ({ commit, dispatch }, user) => {
      return new Promise((resolve, reject) => {
        commit(AUTH_REQUEST);
        axios.post(API+'/auth', user).then(res => {
          if (res.status == 200 && res.data.Token) {
            const Token = res.data.Token;
            commit(AUTH_SUCCESS,Token);
          }else{
            commit(AUTH_ERROR, res.data.error);
          }
          resolve(res);
        }).catch(err => {
          commit(AUTH_ERROR, err);
          localStorage.removeItem("vetc-token");
          reject(err);
        });
      });
    },
    [AUTH_LOGOUT]: ({ commit }) => {
      return new Promise(resolve => {
        localStorage.removeItem('vetc-token')
        commit(AUTH_LOGOUT)
        router.push('dang-nhap')
        resolve()
      })
    },
  }